import React from "react";
import { Menu } from "antd";

interface SideMenuProps {
    changeActiveTab: (tabName: string) => (event: React.MouseEvent) => void
}

const SideMenu: React.FC<SideMenuProps> = ({ changeActiveTab }) => {
    return (
        <Menu
          defaultSelectedKeys={['1']}
          mode='inline'
          theme='light'
          style={{ height: '100%', borderRight: 0 }}
        >
            <Menu.Item key="1">
                <p onClick={changeActiveTab('polls')}>Polls</p>
            </Menu.Item>
            <Menu.Item key="2">
                <p onClick={changeActiveTab('groups')}>Groups</p>
            </Menu.Item>
            <Menu.Item key="3">
                <p onClick={changeActiveTab('contacts')}>Contacts</p>
            </Menu.Item>
            <Menu.Item key="4">
                <p onClick={changeActiveTab('about')}>About</p>
            </Menu.Item>
        </Menu>
    )
};

export default SideMenu;
        